// src/features/user/userApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const loginApi = createApi({
  reducerPath: "loginApi", // Key in the Redux state
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_SERVER, // e.g., "https://auth.jaano.ai"
    credentials: "include",
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  /**
   * Mutation for logging in a user.
   * @function loginUser
   * @param {Object} credentials - The login credentials { email, password }
   * @returns {Object} - The API response including token or user data
   */
  endpoints: (builder) => ({
    loginUser: builder.mutation({
      query: (credentials) => ({
        url: "/auth/login",
        method: "POST",
        body: credentials,
      }),
    }),
  }),
});

export const { useLoginUserMutation } = loginApi;
